<template>
  <b-sidebar
    id="add-new-menu-sidebar"
    :visible="isAddNewMenuSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-xl"
    shadow
    backdrop
    no-header
    right
    @hidden="resetModalData"
    @change="(val) => $emit('update:is-add-new-menu-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ button_text }} New Menu</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <span
            style="
              margin-bottom: 0.2857rem;
              color: #5e5873;
              font-size: 0.857rem;
            "
            >Menu Image</span
          >
          <el-upload
            class="avatar-uploader"
            list-type="picture-card"
            ref="upload"
            :action="uploadUrl"
            :headers="headerObj"
            name="image_file"
            :file-list="fileList"
            multiple
            :limit="1"
            :data="menuData"
            :on-success="uploadSuccess"
            :on-error="uploadFail"
            :on-change="onChange"
            :on-remove="toggleUpload"
            :before-remove="beforeRemove"
            :auto-upload="false"
            :class="{ hideUpload: !showUpload }"
          >
          </el-upload>

          <!-- TITLE -->
          <validation-provider
            #default="validationContext"
            name="Title"
            rules="required"
          >
            <b-form-group label="Title" label-for="menu_title">
              <b-form-input
                id="menu_title"
                v-model="menuData.menu_title"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Title"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- CONTENT -->
          <b-form-group label="Content" label-for="menu_content">
            <b-form-textarea
              id="menu_content"
              v-model="menuData.menu_content"
              autofocus
              trim
              rows="3"
              placeholder="Content"
            />
          </b-form-group>

          <!-- Price -->
          <!-- <validation-provider
            #default="validationContext"
            name="Price"
            rules="required"
          >
            <b-form-group label="Price" label-for="price">
              <b-form-input
                id="price"
                v-model="menuData.price"
                :state="getValidationState(validationContext)"
                trim
              />
            <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->
          <br />
          <br />
          <div v-if="menuData.menu_category_id == 96">
            <h4>Embassy Events</h4>
            <hr />

            <!-- Field: Event Content-->
            <b-col cols="12" md="12">
              <validation-provider
                #default="validationContext"
                name="Event Content"
              >
                <b-form-group
                  class="required"
                  label="Event Content"
                  label-for="event_content"
                >
                  <quill-editor
                    id="event_content"
                    class="custome-editor"
                    v-model="menuData.event_content"
                  />
                  <!-- <b-form-input
                    id="event_content"
                    :state="getValidationState(validationContext)"
                    v-model="menuData.event_content"
                  /> -->
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <br />
            <br />
          </div>

          <div v-if="menuData.menu_category_id == 97">
            <h4>Embassy Services</h4>
            <hr />

            <!-- Field: Event Content-->
            <b-col cols="12" md="12">
              <validation-provider
                #default="validationContext"
                name="Event Content"
              >
                <b-form-group
                  class="required"
                  label="Event Content"
                  label-for="event_content"
                >
                  <quill-editor
                    id="event_content"
                    class="custome-editor"
                    v-model="menuData.event_content"
                  />
                  <!-- <b-form-input
                    id="event_content"
                    :state="getValidationState(validationContext)"
                    v-model="menuData.event_content"
                  /> -->
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <br />
            <br />
          </div>

          <!-- Menu Category ID -->
          <validation-provider
            #default="validationContext"
            name="Category"
            rules="required"
          >
            <b-form-group
              label="Category"
              label-for="menu_category_id"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="menuData.menu_category_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categoryOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                input-id="menu_category_id"
              />
              <b-form-invalid-feedback
                :state="getValidationState(validationContext)"
              >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>

              <!-- Form Actions -->
              <div class="d-flex mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  type="submit"
                >
                  {{ button_text }}
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="button"
                  variant="outline-secondary"
                  @click="hide"
                >
                  Cancel
                </b-button>
              </div>
            </b-form-group>
          </validation-provider>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BCol,
  BMedia,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BImg,
  BCardText,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { getUserData } from "@/auth/utils";
// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import useMenusList from "./useMenusList";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormTextarea,
    BButton,
    vSelect,
    BCol,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BImg,
    BCardText,
    quillEditor,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewMenuSidebarActive",
    event: "update:is-add-new-menu-sidebar-active",
  },
  props: {
    isAddNewMenuSidebarActive: {
      type: Boolean,
      required: true,
    },
    categoryOptions: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  methods: {
    hide() {
      this.$emit("update:is-add-new-menu-sidebar-active", false);
      //isAddNewMenuSidebarActive
    },
    toggleUpload() {
      this.showUpload = !this.showUpload;
    },
    beforeRemove(file) {
      console.log("file.url", file.url);
      console.log(
        "process.env.VUE_APP_IMAGE_URL+this.menuData.image",
        process.env.VUE_APP_IMAGE_URL + this.menuData.image
      );
      console.log(
        "check",
        file.url == process.env.VUE_APP_IMAGE_URL + this.menuData.image
      );

      if (file.url == process.env.VUE_APP_IMAGE_URL + this.menuData.image) {
        this.removeExistingPic = true;
        this.menuData.image = null;
        this.menuData.file = null;
      }
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();
          formData.append("image_file", this.menuData.file);
          formData.append("id", this.menuData.id);
          formData.append("store_id", this.menuData.store_id);
          formData.append("menu_title", this.menuData.menu_title);
          formData.append("menu_content", this.menuData.menu_content);
          formData.append("event_content", this.menuData.event_content);
          formData.append("menu_category_id", this.menuData.menu_category_id);
          formData.append("price", this.menuData.price);
          formData.append("removeExistingPic", this.removeExistingPic);

          this.loading = true;
          store
            .dispatch("bar-menu/addMenu", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.removeExistingPic = false;
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    resetModalData(){
      this.menuData.id = 0
      this.menuData.file = null
      this.menuData.id = null
      this.menuData.store_id = null
      this.menuData.menu_title = null
      this.menuData.menu_content = null
      this.menuData.event_content = null
      this.menuData.menu_category_id = null
      this.menuData.price = null
      this.removeExistingPic = false
      this.showUpload = true
      this.fileList = [];
    }
  },
  data() {
    return {
      required,
      alphaNum,
    };
  },
  setup(props, { emit }) {
    const refInputEl = ref(null);
    const refPreviewEl = ref(null);
    const upload = ref(null);
    const uploadUrl = ref(process.env.VUE_APP_SERVICE_URL + "/menu");
    const headerObj = {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    };
    const fileList = ref([]);
    const button_text = ref("Add");
    const showUpload = ref(true);
    const removeExistingPic = ref(false);
    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        refPreviewEl.value.src = base64;
      }
    );

    const blankMenuData = {
      id: 0,
      menu_title: "",
      menu_content: "",
      store_id: getUserData().store_id,
      price: null,
      menu_category_id: null,
      categories: null,
    };
    watch(
      () => [props.id, props.isAddNewMenuSidebarActive],
      () => {
        /* ... */
        if (props.id > 0 && props.isAddNewMenuSidebarActive) {
          store
            .dispatch("bar-menu/fetchMenu", props.id)
            .then((response) => {
              menuData.value = { ...response.data.menu };
              if (menuData.value.image) {
                fileList.value = [
                  {
                    name: response.data.menu.menu_title,
                    url:
                      process.env.VUE_APP_IMAGE_URL + response.data.menu.image,
                  },
                ];
                showUpload.value = false;
              }
              if (props.id > 0) {
                button_text.value = "Edit";
              } else {
                button_text.value = "Add";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (props.id == 0) {
          menuData.value = JSON.parse(JSON.stringify(blankMenuData));
          fileList.value = [];
          button_text.value = "Add";
        }
      }
    );

    const menuData = ref(JSON.parse(JSON.stringify(blankMenuData)));
    const resetmenuData = () => {
      menuData.value = JSON.parse(JSON.stringify(blankMenuData));
      fileList.value = [];
      button_text.value = "Add";
    };

    const updatemenuData = (menu) => {
      menuData.value = menu;
    };
    const onChange = (file, fileLists) => {
      fileList.value = fileLists;
      menuData.value.file = file.raw;
      console.log("menuData.value.file", menuData.value.file);
      showUpload.value = !showUpload.value;
    };

    /*
    const onSubmit = () => {
      console.log(fileList.value);
      if (menuData.value.id > 0) {
        console.log(fileList.value[0].url);
        if (fileList.value[0].url.includes(process.env.VUE_APP_IMAGE_URL)) {
          //Check if user didn't change photo
          console.log(`user didn't change photo`);
          store
            .dispatch("bar-menu/addMenu", menuData.value)
            .then((response) => {
              uploadSuccess();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log(`user changed photo`);
          upload.value.submit();
        }
      } else {
        upload.value.submit();
      }
    };
    */

    const uploadSuccess = (res, file, fileList) => {
      emit("refetch-data");
      emit("update:is-add-new-menu-sidebar-active", false);
      showMessage(
        "Success",
        "Successfully inserted new menu.",
        "CheckIcon",
        "success"
      );
    };

    const uploadFail = (err, file, fileList) => {
      //showMessage('Fail', err, 'HeartIcon', 'danger')
      console.log("upload Fail");
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetmenuData);

    const { showMessage } = useMenusList();

    return {
      refInputEl,
      menuData,
      //onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      inputImageRenderer,
      refPreviewEl,
      upload,
      uploadUrl,
      uploadSuccess,
      uploadFail,
      onChange,
      headerObj,
      updatemenuData,
      fileList,
      button_text,
      showUpload,
      removeExistingPic,
    };
  },
};
</script>

<style>
</style>